import React, { useEffect, useState } from "react";
import baseRequest from "../../utils/baseRequest";
import {
  DatePicker,
  Table,
  Form,
  Space,
  Button,
  Input,
  Select,
  Modal,
} from "antd";
import { ConfigProvider } from "antd";
import zhCN from "antd/es/locale/zh_CN";
const { confirm } = Modal;
export default function SpaceMemberRefundQuerry() {
  const { RangePicker } = DatePicker;
  const [data, setData] = useState([]);
  const [offset, setOffset] = useState(0);
  const [more, setMore] = useState(1);
  const [total, setTotal] = useState(0);
  const [form] = Form.useForm();
  useEffect(() => {
    handleQuerry({ refunds_status: 6, offset: 0, more: 1 });
  }, []);
  //表头
  const columns = [
    {
      title: "基本信息",
      dataIndex: "base",
      key: "base",
      render: (data) => {
        return (
          <div>
            <p>
              <span className="text-green-400">订单号：</span>
              {data.order_id}
            </p>

            {/* <p>
              <span className="text-green-400">ID：</span>
              {data.id}
            </p> */}
            <p>
              <span className="text-green-400">创建时间：</span>
              {data.ct}
            </p>
            <p>
              <span className="text-green-400">完结时间：</span>
              {data.refunds_status === 6 || data.refunds_status === 1
                ? "-"
                : data.ft}
            </p>
            <p>
              <span className="text-red-400">订单状态：</span>
              {data.refunds_status_desc}
            </p>
          </div>
        );
      },
    },
    {
      title: "金额",
      dataIndex: "cost",
      key: "cost",
      render: (data) => {
        return (
          <div>{data.money !== undefined && <p>¥{data.money / 100}</p>}</div>
        );
      },
    },
    {
      title: "购买（双）方",
      dataIndex: "userAndStreamer",
      key: "userAndStreamer",
      render: (data) => {
        return (
          <div>
            <p>
              <span className="text-green-400">用户id：</span>
              {data.user_user_id}
            </p>
            <p>
              <span className="text-green-400">用户昵称：</span>
              {data.user_name}
            </p>
            <hr />
            {data.streamer_user_id !== 0 && (
              <div>
                <p>
                  <span className="text-green-400">达人id：</span>
                  {data.streamer_user_id}
                </p>
                <p>
                  <span className="text-green-400">达人昵称：</span>
                  {data.streamer_name}
                </p>
              </div>
            )}
          </div>
        );
      },
    },
    {
      title: "退款备注",
      dataIndex: "refundNote",
      key: "refundNote",
      render: (data) => {
        return (
          <div>
            <p>
              <span className="text-green-400">联系人：</span>
              {data.contact_name}
            </p>
            <p>
              <span className="text-green-400">联系电话：</span>
              {data.contact_phone}
            </p>
            <p>
              <span className="text-green-400">退款原因：</span>
              {data.note}
            </p>
          </div>
        );
      },
    },
    {
      title: "操作",
      dataIndex: "opeartion",
      key: "opeartion",
      render: (data, record) => {
        const passNum = [2, 3, 4, 7, 9];
        const refuseNum = [-1, 8];

        return (
          <Space>
            {passNum.includes(data) && <Button disabled>已退款</Button>}
            {refuseNum.includes(data) && <Button disabled>已拒绝</Button>}
            {data === 6 && (
              <>
                <Button
                  type="primary"
                  onClick={() => {
                    confirm({
                      title: "警告",
                      content: "确定要同意退款吗？",
                      cancelText: "取消",
                      okText: "确定",
                      maskClosable: false,
                      centered: true,
                      destroyOnClose: true,
                      onOk: () => handleRefund(record.audit_id, 7),
                      onCancel() {},
                    });
                  }}
                >
                  同意退款
                </Button>
                <Button
                  className="bg-red-400 text-white"
                  onClick={() => {
                    confirm({
                      title: "警告",
                      content: "确定要拒绝退款吗？",
                      cancelText: "取消",
                      okText: "拒绝",
                      okButtonProps: { className: "bg-red-400 text-white" },
                      maskClosable: false,
                      centered: true,
                      destroyOnClose: true,
                      onOk: () => handleRefund(record.audit_id, 8),
                      onCancel() {},
                    });
                  }}
                >
                  拒绝退款
                </Button>
              </>
            )}
          </Space>
        );
      },
    },
  ];

  //搜索
  const handleQuerry = async (value, reSearch) => {
    try {
      const base = baseRequest();
      //金币订单查询
      const response = await fetch(`/op/vas/zone_refund_list`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          st: value.time ? Math.floor(value.time[0].valueOf() / 1000) : 0,
          et: value.time ? Math.floor(value.time[1].valueOf() / 1000) : 0,
          user_id: value.user_id ? parseInt(value.user_id, 10) : 0,
          mid: value.mid ? parseInt(value.mid, 10) : 0,
          order_id: value.order_id ? value.order_id : "",
          refunds_status: value.refunds_status
            ? parseInt(value.refunds_status, 10)
            : 0,
          offset: value.offset,
          limit: 40,
          more: value.more,
          ...base,
        }),
      });
      const _data = await response.json();
      if (_data.ret === -1) {
        alert(_data.msg);
        return false;
      }
      const structedData = _data.data.list.map((item, index) => {
        return {
          key: index,
          audit_id: item?.audit_id,
          base: {
            order_id: item.order_id,
            refunds_status: item.refunds_status,
            refunds_status_desc: item.refunds_status_desc,
            ct: new Date(item.ct * 1000).toLocaleString(),
            ft: new Date(item.ft * 1000).toLocaleString(),
          },
          cost: {
            money: item?.money,
          },
          userAndStreamer: {
            user_user_id: item?.user_user_id,
            streamer_user_id: item?.streamer_user_id,
            streamer_name: item?.streamer_name,
            user_name: item?.user_name,
          },
          refundNote: {
            contact_name: item?.contact_name,
            contact_phone: item?.contact_phone,
            note: item?.note,
          },
          opeartion: item?.refunds_status,
        };
      });
      if (_data.data.offset > 0) {
        setTotal(_data.data.offset);
      }
      setOffset(_data.data.offset);
      setMore(_data.data.more);
      if (reSearch) {
        setData(structedData);
      } else {
        setData((old) => [...old, ...structedData]);
      }
      // setData(structedData);
    } catch (error) {
      console.error(error);
    }
  };
  // 处理退款
  const handleRefund = async (id, status) => {
    const base = baseRequest();
    //金币订单查询
    const response = await fetch(`/op/vas/refund_audit`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        audit_id: id,
        refunds_status: status,
        ...base,
      }),
    });
    const _data = await response.json();
    if (_data.ret === -1) {
      alert(_data.msg);
      return false;
    }
    handleQuerry({ ...form?.getFieldsValue(), offset: 0, more: 1 }, true);
  };
  //表单提交失败
  const onFinishFailed = (errorInfo) => {
    console.log("Failed:", errorInfo);
  };

  return (
    <div className="px-4">
      <h1>订单查询</h1>
      <p className="text-red-400">*以下字段择一填写进行查询</p>
      <ConfigProvider locale={zhCN}>
        <Form
          form={form}
          name="querry"
          onFinish={(value) =>
            handleQuerry({ ...value, offset: 0, more: 1 }, true)
          }
          onFinishFailed={onFinishFailed}
          initialValues={{ refunds_status: "6" }}
          className="flex flex-col mb-6"
        >
          <Space align="start" size={20}>
            <Space direction="vertical" style={{ marginBottom: 20 }}>
              <Form.Item
                label="ID"
                name="user_id"
                className="grow-[4]"
                style={{ margin: 0 }}
              >
                <Input type="number" />
              </Form.Item>
              <Form.Item
                label="mid(开发使用，运营勿用)"
                name="mid"
                style={{ margin: 0 }}
              >
                <Input type="number" />
              </Form.Item>
              <Form.Item label="订单号" name="order_id" style={{ margin: 0 }}>
                <Input type="number" />
              </Form.Item>
              <Form.Item label="时间段" name="time" style={{ margin: 0 }}>
                <RangePicker
                  showTime={{
                    format: "HH:mm",
                  }}
                  showNow
                  format="YYYY-MM-DD HH:mm"
                />
              </Form.Item>
            </Space>
            <Space>
              <Form.Item
                label="订单状态"
                name="refunds_status"
                style={{ margin: 0, width: 300 }}
              >
                <Select defaultValue="6">
                  <Select.Option value="0">全部</Select.Option>
                  <Select.Option value="6">运营待审核</Select.Option>
                  <Select.Option value="7">运营审核通过</Select.Option>
                  <Select.Option value="9">运营审核超时退款</Select.Option>
                  <Select.Option value="8">运营审核拒绝退款</Select.Option>
                  <Select.Option value="1">达人待审核</Select.Option>
                  <Select.Option value="4">达人审核超时</Select.Option>
                  <Select.Option value="2">达人审核同意退款</Select.Option>
                  <Select.Option value="-1">达人审核拒绝退款</Select.Option>
                  <Select.Option value="3">
                    （旧）两小时内自动退款
                  </Select.Option>
                </Select>
              </Form.Item>
            </Space>
          </Space>
          <Space>
            <Button
              type="primary"
              htmlType="submit"
              className="self-start px-20"
            >
              搜索
            </Button>
            {/* <Button type="dashed" className="self-start px-20">
            导出表格
          </Button> */}
          </Space>
        </Form>
      </ConfigProvider>

      <Table
        columns={columns}
        dataSource={data}
        pagination={{ pageSize: 20, total: total, showSizeChanger: false }}
        scroll={{ x: "max-content", y: window.innerHeight - 300 }}
        footer={() => <div className="text-gray-400">获得总数：{total}</div>}
        onScroll={(e) => {
          const { scrollHeight, scrollTop, clientHeight } = e.currentTarget;
          if (scrollTop + clientHeight + 5 >= scrollHeight && more) {
            handleQuerry({ ...form?.getFieldsValue(), offset, more });
          }
        }}
      />
    </div>
  );
}
